import * as React from "react";
import Page from "./Page";

interface PaginationProps {
  page: Page<any>;
  changePage: (number: number) => any;
}

export default class PaginationBar extends React.Component<PaginationProps> {
  render() {
    const startItemIndex = this.props.page.totalElements
      ? this.props.page.number * this.props.page.size + 1
      : this.props.page.totalElements;
    const endItemIndex = this.props.page.totalElements
      ? startItemIndex + this.props.page.numberOfElements - 1
      : this.props.page.totalElements;
    return (
      <div className="pagination-bar h-flex centered">
        <span>{`${i18n["PaginationBar.Label"]} ${startItemIndex}-${endItemIndex} ${i18n["PaginationBar.Total"]} ${this.props.page.totalElements}`}</span>
        {!this.props.page.first ? (
          <i
            className="ic_chevron_left"
            onClick={() => this.props.changePage(this.props.page.number - 1)}
          />
        ) : (
          <i className="ic_chevron_left disabled" />
        )}
        {!this.props.page.last ? (
          <i
            className="ic_chevron_right"
            onClick={() => this.props.changePage(this.props.page.number + 1)}
          />
        ) : (
          <i className="ic_chevron_right disabled" />
        )}
      </div>
    );
  }
}
